<template>
    <div class="ulListClass" :style="
        {
            width: boxStyle.width
        }
    ">
        <img v-show="isMuch" :src="require('../assets/img/ToTop.png')" @click="ToTopFn" />
        <div ref="divBoxNode" class="flex" :style="{height: boxStyle.maxHeight, position: 'relative',width: '100%',overflow: 'hidden'}">
            <ul class="leftBox" ref="ulBoxNode">
                <li ref="liBoxNode" @click="$emit('changeIndex', {name: clickIndex, value: index})" :class="{active: nowIndex == index}" v-for="(item, index) in dataList" :key="index">
                    <span></span>
                    <span>{{item[nameStr]}}</span>
                </li>
            </ul>
        </div>
        <img v-show="isMuch" :src="require('../assets/img/ToBottom.png')" @click="ToBottomFn" />
    </div>
</template>
<script>
export default {
    name: 'UlLists',
    props: {
        nameStr: {
            type: String,
            default: 'abbreviation'
        },
        dataList: {
            type: Array,
            default: () => new Array()
        },
        nowIndex: {
            type: Number,
            default: 0
        },
        clickIndex: {
            type: String,
            default: ''
        },
        boxStyle: {
            type: Object,
            default: () => new Object()
        }
    },
    data(){
        return{
            isMuch: false
        }
    },
    mounted(){
        if(this.$refs.divBoxNode.offsetHeight < this.$refs.ulBoxNode.offsetHeight){
            this.$refs.divBoxNode.style.height = Number(this.$refs.liBoxNode[0].offsetHeight) * 5 + Number(window.getComputedStyle(this.$refs.liBoxNode[0]).marginBottom.slice(0, -2)) * 4 + 'px';
            this.$refs.ulBoxNode.style.position = 'absolute';
            this.$refs.ulBoxNode.style.top = 0;
            this.isMuch = true;
        }
    },
    methods: {
        ToTopFn(){
            const ulBox = this.$refs.ulBoxNode;
            const marginPX = Number(window.getComputedStyle(this.$refs.liBoxNode[0]).marginBottom.slice(0, -2));
            if(Math.abs(ulBox.style.top.slice(0,-2)) <= 0){
                return false;
            }
            ulBox.style.top = Number(ulBox.style.top.slice(0, -2)) + Number(this.$refs.liBoxNode[0].offsetHeight) + marginPX + 'px';
        },
        ToBottomFn(){
            const ulBox = this.$refs.ulBoxNode;
            const divBox = this.$refs.divBoxNode;
            const marginPX = Number(window.getComputedStyle(this.$refs.liBoxNode[0]).marginBottom.slice(0, -2));
            if((Math.abs(ulBox.style.top.slice(0,-2)) + divBox.offsetHeight) >= ulBox.offsetHeight){
                return false;
            }
            ulBox.style.top = Number(ulBox.style.top.slice(0, -2)) - Number(this.$refs.liBoxNode[0].offsetHeight) - marginPX + 'px';
        }
    }
}
</script>
<style lang="less" scoped>
    .ulListClass{
        height: 100%;
        .flexColumnAround();
        img{
            display: block;
            height: 0.18rem;
            margin: 0 auto;
            &:first-child{
                margin-bottom: 0.1rem;
            }
            &:last-child{
                margin-top: 0.1rem;
            }
            cursor: pointer;
        }
    }
    .leftBox{
        transition: all 0.5s;
        width: 100%;
        .active{
            background: #052666;
        }
        li{
            width: 100%;
            height: 0.34rem;
            box-sizing: border-box;
            border: 1px solid #1A3F81;
            line-height: 0.34rem;
            font-size: 0.16rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            border-radius: 0.15rem;
            padding-left: 0.1rem;
            cursor: pointer;
            color: #02D9FD;
            margin-bottom: 0.16rem;
            &:last-child{
                margin-bottom: 0;
            }
            span:first-child{
                width: 0.24rem;
                height: 0.24rem;
                background-image: url('../assets/img/TopBarIcon.png');
                vertical-align: middle;
                background-size: 100% 100%;
                margin-right: 0.16rem;
                display: inline-block;
            }
        }
    }
</style>